window.addEventListener('load', function () {
  let currentSlideIndex = 0;
  const slides = window.HeroShowcaseSlider.slides;
  const slideInterval = 5000; // Set your interval in milliseconds
  const progressInterval = slideInterval / 10; // Set your progress interval in milliseconds
  const heading = document.querySelector('.hero-collection-name');
  const subheading = document.querySelector('.hero-collection-desc');
  const button = document.querySelector('.hero-collection-cta');
  const productShowcaseTitle = document.querySelector('.hero-product-showcase-title');
  const suggestedProductsContainer = document.querySelector('.hero-suggested-products');
  const progressBarInners = document.querySelectorAll('.hero-slider-progress-bar-inner');
  const productCards = document.querySelectorAll('.hero-product-card');
  const bgImages = document.querySelectorAll('.hero-bg-image');
  function updateSliderContent(first = false) {
    // Increment the slide index or reset to 0 if it reaches the end
    if (!first) currentSlideIndex = (currentSlideIndex + 1) % slides.length;
    // Get the current slide
    const currentSlide = slides[currentSlideIndex];

    // Update the elements with the data from the current slide
    heading.innerText = currentSlide.heading;
    heading.style.fontSize = currentSlide.heading_size + 'px';
    subheading.innerText = currentSlide.subheading;
    if (currentSlide.highlighted_products.length > 0) {
      suggestedProductsContainer.style.display = 'flex';
      productShowcaseTitle.innerText = currentSlide.product_showcase_text;
      productCards.forEach(function (card, index) {
        const cardSlideIndex = parseInt(card.dataset.slide);
        if (cardSlideIndex === currentSlideIndex) {
          card.classList.remove('visually-hidden');
        } else {
          card.classList.add('visually-hidden');
        }
      });
    } else {
      suggestedProductsContainer.style.display = 'none';
    }
    bgImages.forEach(function (image, index) {
      const cardSlideIndex = parseInt(image.dataset.slide);
      if (cardSlideIndex === currentSlideIndex) {
        image.classList.remove('visually-hidden');
      } else {
        image.classList.add('visually-hidden');
      }
    });

    if (currentSlide.button_label) {
      button.style.display = 'flex';
      button.innerText = currentSlide.button_label;
      if (currentSlide.link) {
        button.removeAttribute('role');
        button.removeAttribute('aria-disabled');
        button.href = currentSlide.link;
      } else {
        button.setAttribute('role', 'link');
        button.setAttribute('aria-disabled', 'true');
        button.removeAttribute('href');
      }
    } else {
      button.style.display = 'none';
    }
    resetProgressBar();
    const i = setInterval(updateProgressBar, progressInterval);
    setTimeout(() => clearInterval(i), slideInterval);
    function updateProgressBar() {
      // Update the progress bars
      const increment = 100 / (slideInterval / progressInterval); // Calculate the increment based on the slide interval

      progressBarInners.forEach(function (inner, index) {
        const next = parseFloat(inner.dataset.progress) + increment;
        inner.dataset.progress = index === currentSlideIndex ? next : 0;
        inner.style.transition = inner.dataset.progress > 0 ? `width ${progressInterval}ms linear` : 'none';
        inner.style.width = `${inner.dataset.progress}%`;
      });
    }
    function resetProgressBar() {
      // Reset the progress bars
      progressBarInners.forEach(function (inner) {
        inner.dataset.progress = 0;
        inner.style.transition = 'none';
        inner.style.width = '0';
      });
    }
  }

  function startSlider() {
    // Set up an interval to update content periodically
    updateSliderContent(true);
    setInterval(updateSliderContent, slideInterval); // Update every 100 milliseconds for smoother animation
  }

  startSlider();
});
